module.exports = __webpack_public_path__ + "img/video.4effa440.svg";